import { TransferBusStop } from "@/domain/entities/busStop";

export const useGetTransBusNumber = (busstops?: TransferBusStop[]): string => {
  if (!busstops) return "";
  const busStopsNumber = busstops.map((busstop) => busstop.no).join(", ");
  return busStopsNumber;
};
